import { TFunction } from 'i18next';

import { EventTypeStrategy, EventTypeCellParts } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";

export class ChannelBudgetRemovedEventTypeStrategy implements EventTypeStrategy {
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    const forText = row.eventData.channelName ? <> {t("for")} <b>{row.eventData.channelName}</b></> : "";
    const inText = row.eventData.month ? <> {t("in")} <b>{new Date(row.eventData.month).toLocaleDateString("en-US", { month: "long", year: "numeric" })}</b></> : "";

    return <>{t(`eventTypes.${row.eventType}`)}{forText}{inText}</>;
  }

  getTypeAndDescription(row: TransactionType, t: TFunction): EventTypeCellParts {
    const forText = row.eventData.channelName ? <> {t("for")} <b>{row.eventData.channelName}</b></> : "";
    const inText = row.eventData.month ? <> {t("in")} <b>{new Date(row.eventData.month).toLocaleDateString("en-US", { month: "long", year: "numeric" })}</b></> : "";

    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: <>{forText}{inText}</>
    };
  }
}
